export default __webpack_public_path__ + "static/media/README.a3c0a45d.md";